exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".captcha-fallback .BDC_CaptchaDiv{margin:0 auto!important}.captcha-fallback__loader{height:75px;line-height:75px;text-align:center;background-color:#f9f9f9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/captcha-with-fallback/captcha-with-fallback.styl
// module id = 635
// module chunks = 0